"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.dashboard.heading': 'Centro de planificación',
    'socialMediaPlan.dashboard.desc': 'Crea contenido, elige canales y planifica publicaciones.',
};
